/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const purchaseRoutes = {
  path: '/purchase',
  component: Layout,
  redirect: '/purchase',
  name: 'Purchase',
  alwaysShow: true,
  meta: {
    title: 'purchase',
    icon: 'ShoppingCart',
    permissions: [
      'purchase_requisition_view',
      'purchase_order_view',
      'purchase_view',
      'purchase_return_view',
    ],
  },
  children: [
    /** Purchase managements */
    // Requisition routes
    {
      path: 'requisitions/list',
      component: () => import('../views/purchase-requisition/List'),
      name: 'purchaseRequisitionList',
      meta: {
        title: 'purchaseRequisitionList',
        icon: 'Memo',
        permissions: ['purchase_requisition_view'],
      },
    },
    {
      path: 'requisitions/Create',
      component: () => import('../views/purchase-requisition/Create'),
      name: 'purchaseRequisitionCreate',
      meta: {
        title: 'purchaseRequisitionCreate',
        icon: 'Memo',
        permissions: ['purchase_requisition_add'],
      },
      hidden: true,
    },
    {
      path: 'requisitions/view/:id',
      component: () => import('../views/purchase-requisition/View'),
      name: 'purchaseRequisitionView',
      meta: {
        title: 'purchaseRequisitionView',
        icon: 'Memo',
        permissions: ['purchase_requisition_view'],
      },
      hidden: true,
    },
    {
      path: 'requisitions/edit/:id',
      component: () => import('../views/purchase-requisition/Edit'),
      name: 'purchaseRequisitionEdit',
      meta: {
        title: 'purchaseRequisitionEdit',
        icon: 'Memo',
        permissions: ['purchase_requisition_edit'],
      },
      hidden: true,
    },
    {
      path: 'requisitions/check/:id',
      component: () => import('../views/purchase-requisition/Edit'),
      name: 'purchaseRequisitionCheck',
      meta: {
        title: 'purchaseRequisitionCheck',
        icon: 'Memo',
        permissions: ['purchase_requisition_check'],
      },
      hidden: true,
    },
    {
      path: 'requisitions/approve/:id',
      component: () => import('../views/purchase-requisition/Edit'),
      name: 'purchaseRequisitionApprove',
      meta: {
        title: 'purchaseRequisitionApprove',
        icon: 'Memo',
        permissions: ['purchase_requisition_approve'],
      },
      hidden: true,
    },

    // Order routes
    {
      path: 'orders/list',
      component: () => import('../views/purchase-order/List'),
      name: 'purchaseOrderList',
      meta: {
        title: 'purchaseOrderList',
        icon: 'Memo',
        permissions: ['purchase_order_view'],
      },
    },
    {
      path: 'orders/Create',
      component: () => import('../views/purchase-order/Create'),
      name: 'purchaseOrderCreate',
      meta: {
        title: 'purchaseOrderCreate',
        icon: 'Memo',
        permissions: ['purchase_order_add'],
      },
      hidden: true,
    },
    {
      path: 'orders/view/:id',
      component: () => import('../views/purchase-order/View'),
      name: 'purchaseOrderView',
      meta: {
        title: 'purchaseOrderView',
        icon: 'Memo',
        permissions: ['purchase_order_view'],
      },
      hidden: true,
    },
    {
      path: 'orders/edit/:id',
      component: () => import('../views/purchase-order/Edit'),
      name: 'purchaseOrderEdit',
      meta: {
        title: 'purchaseOrderEdit',
        icon: 'Memo',
        permissions: ['purchase_order_edit'],
      },
      hidden: true,
    },
    {
      path: 'orders/check/:id',
      component: () => import('../views/purchase-order/Edit'),
      name: 'purchaseOrderCheck',
      meta: {
        title: 'purchaseOrderCheck',
        icon: 'Memo',
        permissions: ['purchase_order_check'],
      },
      hidden: true,
    },
    {
      path: 'orders/approve/:id',
      component: () => import('../views/purchase-order/Edit'),
      name: 'purchaseOrderApprove',
      meta: {
        title: 'purchaseOrderApprove',
        icon: 'Memo',
        permissions: ['purchase_order_approve'],
      },
      hidden: true,
    },

    // Purchase routes
    {
      path: 'purchases/list',
      component: () => import('../views/purchase/List'),
      name: 'purchaseList',
      meta: {
        title: 'purchaseList',
        icon: 'Memo',
        permissions: ['purchase_view'],
      },
    },

    {
      path: 'purchases/create',
      component: () => import('../views/purchase/Create'),
      name: 'createPurchase',
      meta: {
        title: 'createPurchase',
        icon: 'edit',
        noCache: true,
        permissions: ['purchase_add'],
      },
      hidden: true,
    },
    {
      path: 'purchases/view/:id',
      component: () => import('../views/purchase/View'),
      name: 'viewPurchase',
      meta: {
        title: 'viewPurchase',
        icon: 'edit',
        noCache: true,
        permissions: ['purchase_view'],
      },
      hidden: true,
    },
    {
      path: 'purchases/edit/:id',
      component: () => import('../views/purchase/Edit'),
      name: 'editPurchase',
      meta: {
        title: 'editPurchase',
        icon: 'edit',
        noCache: true,
        permissions: ['purchase_edit'],
      },
      hidden: true,
    },

    /** Purchase Return routes */
    {
      path: 'returns/list',
      component: () => import('../views/purchase-return/List'),
      name: 'purchaseReturnList',
      meta: {
        title: 'purchaseReturnList',
        icon: 'Memo',
        permissions: ['purchase_return_view'],
      },
    },
    {
      path: 'returns/create/:id',
      component: () => import('../views/purchase-return/Create'),
      name: 'createPurchaseReturn',
      meta: {
        title: 'createPurchaseReturn',
        icon: 'add',
        noCache: true,
        permissions: ['purchase_return_add'],
      },
      hidden: true,
    },
    {
      path: 'returns/view/:id',
      component: () => import('../views/purchase-return/View'),
      name: 'viewPurchaseReturn',
      meta: {
        title: 'viewPurchaseReturn',
        icon: 'view',
        noCache: true,
        permissions: ['purchase_return_view'],
      },
      hidden: true,
    },
    {
      path: 'returns/edit/:id',
      component: () => import('../views/purchase-return/Edit'),
      name: 'editPurchaseReturn',
      meta: {
        title: 'editPurchaseReturn',
        icon: 'edit',
        noCache: true,
        permissions: ['purchase_return_edit'],
      },
      hidden: true,
    },
    {
      path: 'purchase-report',
      component: () => import('../views/purchase/purchase-report'),
      name: 'purchaseReport',
      meta: {
        title: 'purchase Report',
        icon: 'Memo',
        permissions: ['purchase_view'],
      },
      hidden: true,
    },
  ],
};

export default purchaseRoutes;
